import {request} from "../../request/request";

const signOut = {
  create: () => request.create('/oauth/sign-out', null, true),
};

export {signOut};